import { User } from '@/types/models/user';
import { getSelectedPaywallPrice } from '@/features/subscription/utils/pricing/paywallPricing';

export type ResolvePaywallPriceIdParams = {
  selectedPriceId?: string;
  selectedPlan?: 'weekly' | 'annual';
  monthlyPrices: PaddlePrice[];
  weeklyPrices: PaddlePrice[];
  yearlyPrices: PaddlePrice[];
  user?: Pick<User, 'isIntroItem'> | null;
};

export const resolvePaywallPriceId = ({
  selectedPriceId,
  selectedPlan,
  monthlyPrices,
  weeklyPrices,
  yearlyPrices,
  user,
}: ResolvePaywallPriceIdParams): string | undefined => {
  if (selectedPriceId) {
    const matchedPrice = [
      ...weeklyPrices,
      ...monthlyPrices,
      ...yearlyPrices,
    ].find((price) => price.id === selectedPriceId);

    if (matchedPrice) {
      return matchedPrice.id;
    }
  }

  return getSelectedPaywallPrice({
    selectedPlan,
    monthlyPrices,
    weeklyPrices,
    yearlyPrices,
    user,
  })?.id;
};
